
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/sis/jst/-sisButton';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<span class=\"post-to-sis-status\">\n    <label class=\"screenreader-only\" aria-pressed=\"";
  if (helper = helpers.postToSIS) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.postToSIS); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></label>\n    <input type='image' class='icon-post-to-sis' data-tooltip/>\n</span>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/sis/jst/_sisButton.handlebars', templates['/work/generated/ui/shared/sis/jst/-sisButton']);
    ;
    ;
    export default templates[name];
  